<template>
  <div class="user-icon">
    <i class="bqh bqh-geren_2" :style="[{fontSize:size+'px'},{padding:center?'0.5em':'0.9rem 0.5rem 0 0.5rem'}]" />
  </div>
</template>

<script>
export default {
    props:{
        size:{
            type:String,
            default:()=>'26'
        },
        center:{
            type:Boolean,
            default:()=>false
        }
    }
}
</script>

<style lang="scss" scoped>
.user-icon {
    display: flex;
  .bqh {
    color: #0079fe;
    background: #e6f2ff;
    border-radius: 5rem;
    line-height: 1;
  }
}
</style>